import { sizeProp } from "../../propTypes";


export const GlassIcon = ({ size = 24 }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4418_7134)">
                <path d="M15.84 22.75H8.15999C5.47999 22.75 4.25999 21.75 3.71999 20.92C2.92999 19.7 2.95999 18.03 3.80999 16.09L7.63999 7.39C7.10999 7.25 6.61999 6.97 6.22999 6.58C5.65999 6 5.31999 5.2 5.31999 4.37C5.31999 2.65 6.71999 1.25 8.43999 1.25H15.55C16.38 1.25 17.17 1.58 17.76 2.17C18.54 2.95 18.85 4.06 18.59 5.13C18.33 6.2 17.45 7.05 16.37 7.36L20.19 16.1C21.03 18.03 21.06 19.7 20.26 20.92C19.72 21.75 18.5 22.75 15.84 22.75ZM8.43999 2.75C7.54999 2.75 6.81999 3.48 6.81999 4.37C6.81999 4.8 6.99999 5.22 7.28999 5.52C7.58999 5.82 8.00999 5.99 8.43999 5.99H8.73999C8.98999 5.99 9.22999 6.12 9.36999 6.33C9.50999 6.54 9.52999 6.81 9.42999 7.04L5.17999 16.69C4.54999 18.13 4.46999 19.34 4.96999 20.1C5.58999 21.05 7.03999 21.25 8.14999 21.25H15.83C16.93 21.25 18.37 21.05 19 20.1C19.5 19.33 19.43 18.13 18.81 16.7L14.6 7.04C14.5 6.81 14.52 6.54 14.66 6.33C14.8 6.12 15.03 5.99 15.29 5.99H15.45C16.25 5.99 16.97 5.48 17.14 4.77C17.28 4.2 17.12 3.64 16.71 3.23C16.4 2.92 15.99 2.75 15.56 2.75H8.43999Z"/>
                <path d="M13.8401 15.0406C13.1801 15.0406 12.4701 14.9506 11.7601 14.7106C8.92006 13.7606 5.99006 13.8606 5.96006 13.8606C5.56006 13.9206 5.20006 13.5506 5.18006 13.1406C5.16006 12.7306 5.49006 12.3806 5.90006 12.3606C6.03006 12.3506 9.14006 12.2506 12.2301 13.2806C14.8301 14.1506 17.3801 12.5006 17.4101 12.4806C17.7501 12.2506 18.2201 12.3506 18.4501 12.6906C18.6801 13.0306 18.5901 13.5006 18.2401 13.7306C18.1501 13.8006 16.2501 15.0406 13.8401 15.0406Z"/>
            </g>
            <defs>
                <clipPath id="clip0_4418_7134">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
GlassIcon.propTypes = sizeProp
